exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable.details td {\n    padding-left: 3px;\n    padding-right: 3px;\n    font-size: 11px;\n    line-height: 1.3em;\n    height: 15px;\n}\n", ""]);

// exports
